import { Get } from '../../api/axiosCoreConfig';

export const getGenericList = (listName, namespace) =>
    Get(`/list/${listName}?namespace=${namespace}`);
